<template>
	<div>
		<div v-if="loading" class="py-5 text-center">
			<Spinner type="primary">{{ $t('general.loading') }}</Spinner>
		</div>
		<div v-else-if="attachments.length">
			<label v-if="attachments.length > 1" class="block mb-4">
				<span class="block mb-2 font-bold"
					>{{ $t('general.select-attachment') }}:</span
				>
				<select
					v-model="selection"
					class="w-full px-3 py-2 border border-grey-300 rounded-lg bg-white text-grey-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-grey-600"
				>
					<option
						v-for="(attachment, index) in attachments"
						:key="attachmentRenderKey(attachment, index)"
						:value="index"
						>{{ attachment.name }}</option
					>
				</select>
			</label>
			<div v-else class="mb-4">
				<h5 class="font-bold">{{ attachments[0].name }}</h5>
			</div>
			<div v-if="selectedAttachment" class="text-center">
				<iframe
					:src="selectedAttachment.url"
					:title="
						selectedAttachment.name || $t('general.attachments')
					"
					width="100%"
					height="600px"
					class="border border-gray-200 rounded-lg"
				/>
			</div>
		</div>
		<div
			v-else
			class="flex flex-col items-center justify-center gap-2 py-16 text-center border border-gray-200 rounded-lg text-neutral-500 bg-neutral-50"
		>
			<div
				class="flex items-center justify-center w-12 h-12 rounded-full bg-neutral-100"
			>
				<IconFile
					:size="24"
					:aria-hidden="true"
					class="text-grey-700"
				/>
			</div>
			<p class="m-0 text-lg font-medium text-neutral-800">
				{{ $t('general.no-attachments-available') }}
			</p>
			<p class="m-0 text-sm">
				{{ $t('general.applicant-no-attachments-uploaded') }}
			</p>
		</div>
	</div>
</template>

<script>
import IconFile from '~/components/Icons/IconFile'
import Spinner from '~/components/ui/common/Spinner'

export default {
	components: { IconFile, Spinner },
	props: {
		attachments: { type: Array, default: () => [] },
		loading: { type: Boolean, default: false },
		value: { type: Number, default: null }
	},
	computed: {
		selection: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		},
		selectedAttachment() {
			return (
				this.attachments[this.value ?? 0] || this.attachments[0] || null
			)
		}
	},
	methods: {
		attachmentRenderKey(attachment, index = 0) {
			if (!attachment || typeof attachment !== 'object') {
				return `attachment-${index}`
			}

			const base =
				attachment.id ||
				attachment.uuid ||
				attachment.url ||
				attachment.name
			const normalizedBase =
				typeof base === 'string' || typeof base === 'number'
					? base
					: 'attachment'

			return `${normalizedBase}-${index}`
		}
	}
}
</script>
